import type { VoiceTranscript } from '../_contract/voiceInput';
import { VOICE_DECODED_SECONDS } from '../_data/voiceInput';

export function isVoiceTranscript(value: unknown): value is VoiceTranscript {
    return !!value && typeof value === 'object'
        && 'text' in value && typeof value.text === 'string' && !!value.text.trim() && value.text.length <= 4000
        && 'language' in value && typeof value.language === 'string'
        && 'audioSeconds' in value && typeof value.audioSeconds === 'number' && value.audioSeconds > 0 && value.audioSeconds <= VOICE_DECODED_SECONDS
        && 'elapsedMs' in value && typeof value.elapsedMs === 'number' && Number.isFinite(value.elapsedMs) && value.elapsedMs >= 0;
}
